import { RuleCustom } from 'fastest-validator';
import decoratorFactory from '@/utils/validator/decorators/decoratorFactory';
import errorMessages from '@/utils/validator/error.messages';

export interface RuleMinMax extends RuleCustom {
  max?: number
}

export const MinMaxPrice = decoratorFactory<RuleMinMax>({ type: 'minMaxPrice' });

export default {
  messages: {
    minBiggerThanMax: errorMessages.minBiggerThanMax,
  },
  alias: {
    type: 'tuple',
    items: [
      { type: 'number', integer: true, min: 0, convert: true, optional: true },
      { type: 'number', integer: true, min: 0, convert: true, optional: true },
    ],
    default: [null, null],
    custom(value: unknown, errors: {type: string}[]) {
      const minMax = value as [number, number];
      if ((minMax[0] && minMax[1]) && ((minMax[0] > minMax[1]))) errors.push({ type: 'minBiggerThanMax' });
      return value;
    },
  },
};
